import axios from "axios";
import moment from "moment";

const apim = axios.create();
let authHeader;
let refreshTimer: any;

const getToken = async () => {
  const token = localStorage.getItem("okta-access-token");
  try {
    if (token) {
      const { exp } = JSON.parse(atob(token.split(".")[1]));
      const isTokenActive = moment().isBefore(moment(exp * 1000));
      if (isTokenActive) {
        const { data }: { data: any } = await axios.post(
          `${process.env.REACT_APP_APIM_HOST}/oauth/token/validate`,
          null,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (data.valid === "true") {
          clearTimeout(refreshTimer);
          updateHeader(token);
          return true;
        }
      }
    }
    const { data }: { data: any } = await axios.post(
      `${process.env.REACT_APP_APIM_HOST}/oauth/token?scope=guest`
    );
    if (data.access_token) {
      clearTimeout(refreshTimer);
      updateHeader(data.access_token);
      return true;
    }
  } catch (err) {
    console.error(err);
  }
};

const updateHeader = (token: string) => {
  authHeader = `Bearer ${token}`;
  apim.defaults.headers.common["Authorization"] = authHeader;
  localStorage.setItem("okta-access-token", token);
  renewTokenBeforeExpiry(token);
};

const renewTokenBeforeExpiry = (token: string) => {
  const { exp } = JSON.parse(atob(token.split(".")[1]));
  let timeOut = exp * 1000 - Date.now() - 120 * 1000;
  refreshTimer = setTimeout(function () {
    getToken();
  }, timeOut);
};

export { getToken, apim };
